import fieldNames from '../../../common/components/link-field/constants/field-names';
import baseIframeFieldNames from '../../ws-iframe/constants/field-names';

const imageFieldNames = {
  IMAGE_SRC: 'image-src',
  IMAGE_POSITION: 'image-position',
  IMAGE_SCALE: 'image-scale',
  IMAGE_ALT: 'image-alt',
};

const iframeFieldNames = {
  ...baseIframeFieldNames,
};

const linkFieldNames = {
  ...fieldNames,
  LINK_CLICK_ACTION: 'link-click-action',
};

export { imageFieldNames, iframeFieldNames, linkFieldNames };
